import {
  ButtonModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
  TimerModule,
} from '@shared/components/games';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WordsMemoryControllerComponent } from './words-memory-controller/words-memory-controller.component';
import { WordsMemoryRulesComponent } from './tools/words-memory-rules/words-memory-rules.component';
import { WordsMemorySettingsComponent } from './words-memory-settings/words-memory-settings.component';
import { WordsMemoryCorrectAnswerPreviewComponent } from './words-memory-preview/words-memory-answer-preview/words-memory-answer-preview.component';
import { WordsMemoryExamplePreviewComponent } from './words-memory-preview/words-memory-example-preview/words-memory-example-preview.component';
import { WordsMemoryParametersPreviewComponent } from './words-memory-preview/words-memory-parameters-preview/words-memory-parameters-preview.component';
import { WordsMemoryUserAnswerPreviewComponent } from './words-memory-preview/words-memory-user-answer-preview/words-memory-user-answer-preview.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    WordsMemoryControllerComponent,
    WordsMemorySettingsComponent,
    WordsMemoryRulesComponent,
    WordsMemoryCorrectAnswerPreviewComponent,
    WordsMemoryExamplePreviewComponent,
    WordsMemoryParametersPreviewComponent,
    WordsMemoryUserAnswerPreviewComponent,
  ],
  exports: [
    WordsMemoryControllerComponent,
    WordsMemorySettingsComponent,
    WordsMemoryRulesComponent,
    WordsMemoryCorrectAnswerPreviewComponent,
    WordsMemoryExamplePreviewComponent,
    WordsMemoryParametersPreviewComponent,
    WordsMemoryUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FitTextModule,
    FormFieldModule,
    TimerModule,
    NgSelectModule,
    TextsFilterComponent,
    GamesSharedModule,
    MatProgressSpinner,
  ],
})
export class WordsMemoryModule {}
